import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './nav-category.scss.js';
import '../../atoms/buttons/generic-button2.0/index.js';
import '../../atoms/nav-link/index.js';

class NavCategory extends s {
    constructor() {
        super(...arguments);
        this.icon = '';
        this.heading = '';
        this.description = '';
        this.buttonText = '';
        this.buttonHref = '';
        this.buttonTarget = '';
        this.buttonIsNoFollow = false;
        this.links = [];
        this.buttonId = '';
        this.isCMSIcon = false;
    }
    static renderLink(link) {
        return $ `<nav-link .text="${link.text}" .href="${link.link}" .icon="${link.icon}" .isNoFollow="${link.isNoFollow}" .target="${link.target}" .ariaLabel="${link.ariaLabel}"></nav-link>`;
    }
    render() {
        var _a;
        const buttonIdAttr = this.buttonId
            ? `${this.buttonId
                .toLowerCase()
                .replace(/\s+/g, '-')}-nav-category-button`
            : '';
        const descriptionTemplate = this.description
            ? $ `<p class="nav-category__description">${this.description}</p>`
            : '';
        const iconTemplateCMS = $ `<div class="nav-category__icon"><img src="${this.icon.trim()}" alt="" loading="lazy" width="24" height="24" aria-hidden="true"></div>`;
        const materialIconTemplate = this.icon
            ? $ `<div class="nav-category__icon"><span class="material-symbols-outlined" aria-hidden="true">${this.icon.trim()}</span></div>`
            : '';
        const iconTemplate = this.icon && this.isCMSIcon ? iconTemplateCMS : materialIconTemplate;
        const buttonTextTemplate = this.buttonText
            ? $ `<generic-button-updated id="${buttonIdAttr}" class="nav-category__button" .label="${this.buttonText}" .href="${this.buttonHref}" data-surface="Surface/Button/Primary/Purple" .target="${this.buttonTarget}" .isNoFollow="${this.buttonIsNoFollow}"></generic-button-updated>`
            : '';
        const linksTemplate = ((_a = this.links) === null || _a === void 0 ? void 0 : _a.length) > 0
            ? $ `<div class="nav-category__links">${this.links.map(link => NavCategory.renderLink(link))}</div>`
            : '';
        return $ `<div class="nav-category" aria-labelledby="nav-category-heading"><div class="nav-category__header"><div class="nav-category__title-wrapper">${iconTemplate}<h3 id="nav-category-heading" class="nav-category__heading">${this.heading}</h3></div>${descriptionTemplate} ${buttonTextTemplate}</div><slot name="mobile-nav-items"></slot>${linksTemplate}</div>`;
    }
}
NavCategory.styles = css_248z;
__decorate([
    e()
], NavCategory.prototype, "icon", void 0);
__decorate([
    e()
], NavCategory.prototype, "heading", void 0);
__decorate([
    e()
], NavCategory.prototype, "description", void 0);
__decorate([
    e()
], NavCategory.prototype, "buttonText", void 0);
__decorate([
    e()
], NavCategory.prototype, "buttonHref", void 0);
__decorate([
    e()
], NavCategory.prototype, "buttonTarget", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], NavCategory.prototype, "buttonIsNoFollow", void 0);
__decorate([
    e({ type: Array })
], NavCategory.prototype, "links", void 0);
__decorate([
    e({ type: String })
], NavCategory.prototype, "buttonId", void 0);
__decorate([
    e({ type: Boolean })
], NavCategory.prototype, "isCMSIcon", void 0);
customElements.define('nav-category', NavCategory);

export { NavCategory };
